import { Platform } from "react-native";
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import * as SecureStore from "expo-secure-store";

// Create an adapter for web local storage
const WebLocalStorageAdapter = {
  getItem: (key: string) => {
    return typeof localStorage !== 'undefined' ? Promise.resolve(localStorage.getItem(key)) : Promise.resolve(null);
  },
  setItem: (key: string, value: string) => {
    typeof localStorage !== 'undefined' ? localStorage.setItem(key, value) : null;
  },
  removeItem: (key: string) => {
    typeof localStorage !== 'undefined' ? localStorage.removeItem(key) : null;
  },
};

// Create a SecureStore adapter for native platforms
const NativeSecureStoreAdapter = {
  getItem: (key: string) => {
    return SecureStore.getItemAsync(key);
  },
  setItem: (key: string, value: string) => {
    SecureStore.setItemAsync(key, value);
  },
  removeItem: (key: string) => {
    SecureStore.deleteItemAsync(key);
  },
};

// Determine the appropriate storage adapter based on the platform
const storageAdapter = Platform.OS === 'web' ? WebLocalStorageAdapter : NativeSecureStoreAdapter;

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL as string;
const supabaseKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY as string;

// These are inlined by Metro at bundle time, so an empty value here means the bundle was built
// without them rather than that something failed at runtime. createClient() throws a bare
// "supabaseUrl is required." which gives no clue why, and because this module is imported by
// AuthProvider it throws during startup and crashes every launch. Name the real cause instead.
if (!supabaseUrl || !supabaseKey) {
  const missing = [
    !supabaseUrl && 'EXPO_PUBLIC_SUPABASE_URL',
    !supabaseKey && 'EXPO_PUBLIC_SUPABASE_ANON_KEY',
  ]
    .filter(Boolean)
    .join(', ');

  throw new Error(
    `This build is missing ${missing}. EXPO_PUBLIC_* values are inlined when the bundle is built, ` +
      `so this bundle was published without them — check .env.production at the repo root ` +
      `(see apps/crew/scripts/check-public-env.js).`
  );
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storage: storageAdapter,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});
